import { AdminProviderModel, EditState, ProviderEditPageState } from './provider_edit_types';
import utilSvc from '../../../core/utilSvc';
import { ValidOption } from '../../../core/components/validation/types';
import { validPropRadioTextVM } from '../../../core/components/validation/ValidInputRadioText';
import { validPropDroplistTextVM } from '../../../core/components/validation/ValidInputDroplistText';
import { validPropTextVM } from '../../../core/components/validation/ValidInputText';

const faxConsentOptions = [
    { lbl: 'Yes', val: 'true' },
    { lbl: 'No', val: 'false' },
];

const faxAttemptOptions = [
    { lbl: '1', val: 1 },
    { lbl: '2', val: 2 },
    { lbl: '3', val: 3 },
    { lbl: '4', val: 4 },
    { lbl: '5', val: 5 },
];

const faxFrequencyOptions = [
    { lbl: '1', val: '1' },
    { lbl: '2', val: '2' },
    { lbl: '3', val: '3' },
    { lbl: '4', val: '4' },
    { lbl: '5', val: '5' },
    { lbl: '6', val: '6' },
    { lbl: '7', val: '7' },
    { lbl: '8', val: '8' },
    { lbl: '9', val: '9' },
    { lbl: '10', val: '10' },
    { lbl: '11', val: '11' },
    { lbl: '12', val: '12' },
    { lbl: '13', val: '13' },
    { lbl: '14', val: '14' },
];

const validatedOptions = [
    { lbl: 'Yes', val: 'true' },
    { lbl: 'No', val: 'false' },
];

// PAGE
export function pageStateVM(): ProviderEditPageState {
    return {
        init: true,
        title: '',
        canEdit: false,
        mode: '',
        id: '',
    };
}

// EDIT FORM
export function editStateVM(): EditState {
    return {
        init: true,
        waiting: false,
    };
}
export function modelVM(data?): AdminProviderModel {
    data = data || {};

    const stateOptions = utilSvc.loc.stateNames() as ValidOption[];
    stateOptions.unshift({ lbl: 'Not Specified', val: '' });

    return {
        Id: !!data.Id ? data.Id : '',
        Address1: validPropTextVM('Address1', 'Address1', data.Address1),
        Address2: validPropTextVM('Address2', 'Address2', data.Address2),
        City: validPropTextVM('City', 'City', data.City),
        ChangeLog: data.ChangeLog || [],
        Fax: validPropTextVM('Fax', 'Fax', data.Fax),
        FaxAttempts: validPropDroplistTextVM('FaxAttempts', 'Fax Attempts', data.FaxAttempts, '', faxAttemptOptions),
        FaxConsent: validPropRadioTextVM(
            'FaxConsent',
            'Fax Consent',
            `${data.FaxConsent ?? false}`,
            '',
            faxConsentOptions,
        ),
        FaxFrequency: validPropDroplistTextVM(
            'FaxFrequency',
            'Fax Frequency',
            data.FaxFrequency,
            '',
            faxFrequencyOptions,
        ),
        FullName: validPropTextVM('FullName', 'Full Name', data.FullName),
        NPI: validPropTextVM('NPI', 'NPI', data.NPI),
        Phone: validPropTextVM('Phone', 'Phone', data.Phone),
        PracticeName: validPropTextVM('PracticeName', 'Practice Name', data.PracticeName),
        PrimaryTaxonomy: validPropDroplistTextVM(
            'PrimaryTaxonomy',
            'Primary Taxonomy',
            data.PrimaryTaxonomy,
            undefined,
            data.PrimaryTaxonomy?.options,
        ),
        State: validPropDroplistTextVM('State', 'State', data.State, '', stateOptions),
        Validated: validPropRadioTextVM('Validated', 'Validated', `${data.Validated ?? false}`, '', validatedOptions),
        Usage: data.Usage ?? [],
        Zip: validPropTextVM('Zip', 'Zip Code', data.Zip),
    };
}
